import React, { useState, useEffect } from 'react';
import axios from '../../axiosConfig';
import TemasTabla from './TemasTabla';
import Loading from '../../components/globales/Loading';
import Footer from '../../components/globales/Footer';

function Temas() {
	const [temasInicial, setTemasInicial] = useState([]);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);

	useEffect(() => {
		axios.get('/encuestaTema/listar')
			.then(response => {
				setTemasInicial(response.data.data);
				setLoading(false);
			})
			.catch(error => {
				setError(error);
				setLoading(false);
			});
	}, []);

	if (loading) {
		return <div><Loading mensaje={'Cargando Temas...'} /></div>;
	}

	if (error) {
		return <div>Error: {error.message}</div>;
	}

	return (
		<>
			<div className="container-fluid">
				<div className="container">
					<div className="row">
						<div className="col-xs-12 col-sm-12 col-md-12">
							<TemasTabla temasInicial={temasInicial} />
						</div>
					</div>
				</div>
			</div>
		</>
	);
}

export default Temas;
